import { render } from "./Home.vue?vue&type=template&id=ffbee1b6&scoped=true"
import script from "./Home.js?vue&type=script&lang=js"
export * from "./Home.js?vue&type=script&lang=js"

import "./Home.scss?vue&type=style&index=0&id=ffbee1b6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbee1b6"]])

export default __exports__